import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/router'
import store from './store'
import "@fortawesome/fontawesome-free/css/all.min.css"
import Notifications from '@kyvg/vue3-notification'
import { abilitiesPlugin } from '@casl/vue'
import abilities from '@/abilities'
import axios from 'axios'
import { bindAuthGlobalProperties } from '@/app/services/auth.service'
import { touchSession } from '@/composables/tokenRefresh'
import './index.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const app = createApp(App)

bindAuthGlobalProperties(app.config.globalProperties)

app.use(createPinia())
app.use(store)
app.use(router)
app.use(Notifications)
app.component('VueDatePicker', VueDatePicker);

// Setup CASL
app.use(abilitiesPlugin, abilities, {
  useGlobalProperties: true,
})

// Setup Axios interceptors
const user = sessionStorage.getItem("userProfile")
if (user != null) {
  const usr = JSON.parse(user)
  const token = sessionStorage.getItem("token")

  axios.defaults.headers.common = { Authorization: `Bearer ${token}` }

  app.config.globalProperties.$userProfile = usr

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        // Network error - handle if needed
      }

      if (error.response?.status === 401) {
        sessionStorage.clear()
        touchSession()
        window.location.reload()
      }
      return Promise.reject(error)
    }
  )
}

app.mount('#app')
